<span
  class="typo-h7-semibold rounded-md px-2 py-1 text-text-white"
  [ngClass]="{
    'bg-states-white !text-text-blue': status === patientStatus.ARCHIVED,
    'bg-states-light-white': status === patientStatus.INACTIVE,
    'drop-shadow-status-purple bg-states-purple': status === patientStatus.NON_PATIENT,
    'drop-shadow-status-green bg-secondary-green': !status || status === patientStatus.PATIENT
  }"
>
  @switch (status) {
    @case (patientStatus.ARCHIVED) {
      {{ 'patientSearch_status_archived' | translate }}
    }
    @case (patientStatus.INACTIVE) {
      {{ 'patientSearch_status_inactive' | translate }}
    }
    @case (patientStatus.NON_PATIENT) {
      {{ 'patientSearch_status_nonPatient' | translate }}
    }
    @case (patientStatus.PATIENT) {
      {{ 'patientSearch_status_patient' | translate }}
    }
    @default {
      {{ 'patientSearch_status_patient' | translate }}
    }
  }
</span>
